import React, { Component } from 'react';
import moment from 'moment';

class CountDown extends Component {
  state = {
    dateString: moment(this.props.date).fromNow(),
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      const { dateString } = this.state;
      const { date } = this.props;

      if (dateString !== moment(date).fromNow()) {
        this.setState({ dateString: moment(date).fromNow() });
      }
    }, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    const { dateString } = this.state;
    const { style } = this.props;

    return <span style={style}>{dateString.toUpperCase()}</span>;
  }
}

export default CountDown;
